import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import styled from 'styled-components';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
// import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';


import * as firebase from 'firebase';
import sortBy from 'lodash.sortby';
import _ from 'lodash';

import { getOrderPage } from '../../actions/orderActions';
import {
  Header,
  PaginationContainer,
  PageStateContainer,
  PageState
} from '../Styles/index';
import Pagination from '../Pagination/Pagination';
import OrdersTable from './OrderTable';
import OrderSearchResults from './OrderSearchResults';
import LoadingState from '../Loading';

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 32px 16px;
`
const TableContainer = styled.div`

`

class OrderList extends Component {

  state = {
    currentPage: 1,
    totalPages: 1,
    limit: 20,
    orders: [],
    orderBy: 'no',
    orderByItems: ['no', 'date', 'amount', 'client'],
    showTable: true,

    searchResults: [],
    searchQuery: '',
  }

  _handleSearchChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim()
    });

    if (event.target.value.trim() === '') {
      this.setState({
        showTable: true
      })
    } else {
      this._handleSearch(event.target.value.trim())
    }

  }

  _handleSearchSubmit = event => {
    event.preventDefault();
    this._handleSearch(this.state.searchQuery)
  }

  _handleSearch(query){
    firebase.database().ref().child('clients')
    .orderByChild('name').startAt(query).endAt(`${query}\uf8ff`)
    .on('value', snapshot => {

      this._attachAllOrders(snapshot)
      .then(allOrders => {
        const orderKeysWithClient = _.flatten(allOrders);
        return this._attachCartDetails(orderKeysWithClient)
      })
      .then(orders => {
        console.log(orders,'----');
        this.setState({
          searchResults: orders,
          showTable: false
        })
      })
    })
  }

  _attachAllOrders(snapshot){
    const allOrders = [];
    snapshot.forEach(client => {
      allOrders.push(new Promise((resolve, reject) => {
        firebase.database().ref().child('orders').orderByValue().equalTo(client.key).on('value', orders => {
          if (!orders.val()) {return resolve([])}

          const orderKeys = []
          orders.forEach(order => {
            orderKeys.push({ orderKey: order.key, client: {...client.val(), key: client.key } });
          })
          resolve(orderKeys)
          
        })
      }))
    })
    return Promise.all(allOrders)
  }

  _attachCartDetails(orderKeysWithClient){
    const cartList = [];
    orderKeysWithClient.forEach(({ orderKey, client }) => {
      cartList.push(new Promise((resolve, reject) => {
        firebase.database().ref().child('cart_sessions').child(orderKey).on('value', cart => {
          resolve({ ...cart.val(), key: cart.key, client: client });
        })
      }))
    })
    return Promise.all(cartList);
  }

  _handleSearchBack = event => {
    this.setState({
      showTable: true,
      searchResults: [],
      searchQuery: ''
    })
  }

  _orderBy(value){
    switch (value) {
      case 'date':
        return sortBy(this.state.orders, value =>  new Date(value.date));
      case 'amount': 
        return sortBy(this.state.orders, order => {
          let amount = 0;
          for (const key in order.products) {
            amount += order.products[key];
          }
          return amount
        });
      case 'client':
        return sortBy(this.state.orders, order => order.client.name)
      default:
        return sortBy(this.state.orders, [value]);
    }
  }

  _handleChange = (event, index, value) => {
    const orders = this._orderBy(value);
    console.log(orders)
    this.setState({
      orderBy: value,
      orders
    });
  }

  _onPageChange = page => {
    this.props.history.push(`${this.props.location.pathname}?page=${page}`);
    this.props.getOrderPage({limit: this.state.limit, page: page})
    .then(res => {
      if (this.props.orders.status === 'fetched') {
        this.setState({
          orders: this.props.orders.data,
          currentPage: page
        }, () => {
          const orders = this._orderBy(this.state.orderBy);
          this.setState({ orders })
        })
      }
    });
  }

  _goToEditPage = (code) => {
    this.props.history.push(`/orders/edit?order=${code}`);
  }

  _refreshPage = () => {
    if (this.state.orders.length <= 1) {
      this.setState({
        currentPage: this.state.currentPage - 1,
      })
    }

    this.props.getOrderPage({limit: this.state.limit, page: this.state.currentPage})
    .then(_ => {
      if (this.props.orders.status === 'fetched') {
        this.setState({
          orders: this.props.orders.data,
        })
      }
    });
    this.props.history.push(`${this.props.location.pathname}?page=${this.state.currentPage}`);
  }

  _setTotalPages(){
    firebase.database().ref().child('order_count').on('value', snapshot => {
      this.setState({
        totalPages: Math.ceil(snapshot.val() / this.state.limit)
      });
    })
  }

  componentDidMount() {
    const parsedQuery = queryString.parse(this.props.location.search);
    const page = (parsedQuery.page ? parsedQuery.page : 1) | 0;
    this._setTotalPages();
    this.props.getOrderPage({ page: page, limit: this.state.limit })
      .then(_ => {
        if (this.props.orders.status === 'fetched') {
          console.log(this.props.orders)
          this.setState({
            orders: this.props.orders.data,
            currentPage: page
          }, () => {
            const orders = this._orderBy(this.state.orderBy);
            this.setState({ orders })
          })
        }
      });
  }

  render(){
    const tableHeader = ['No', 'Date', 'Amount', 'Client', 'Status', 'Active', 'Notes', ''];
    return(
      <Container>
        <Header>
          <div style={{flex: 1, height: '74px', paddingRight: '24px'}}>
            {!this.state.showTable &&
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                label="Back"
                onTouchTap={this._handleSearchBack}
                icon={<NavigationArrowBack />}
              />
            }
            {this.state.showTable && <SelectField
              floatingLabelText="Sort By"
              value={this.state.orderBy}
              onChange={this._handleChange}
            >
              {this.state.orderByItems.map((item, index) => <MenuItem key={index} value={item} primaryText={item}/>)}
            </SelectField>}
          </div>
          <div>
            <form onSubmit={this._handleSearchSubmit}>
              <TextField
                name="searchQuery"
                id="searchQuery"
                onChange={this._handleSearchChange}
                value={this.state.searchQuery}
                hintText="Search orders"
              />
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                icon={<ActionSearch />}
              />
            </form>
          </div>
        </Header>
        {this.props.orders.loading 
          ? <LoadingState/>
          : <div>
            { this.state.showTable &&
              <div>
                <TableContainer>
                  <OrdersTable  refreshPage={this._refreshPage}  headers={tableHeader} editHandler={this._goToEditPage} tableData={this.state.orders} height={this.props.orders.data.length*48}/>
                </TableContainer>
                <PaginationContainer>
                  <PageStateContainer>
                    <PageState>{this.state.currentPage} / {this.state.totalPages}</PageState>
                  </PageStateContainer>
                  <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this._onPageChange}/>
                </PaginationContainer>
              </div>
            }
            { !this.state.showTable &&
              <div>
                <OrderSearchResults 
                  refreshPage={this._refreshPage} 
                  goToEditPage={this._goToEditPage} 
                  query={this.state.searchQuery} 
                  orders={this.state.searchResults}
                />
              </div>
            }
          </div>
        }

      </Container>
    )
  }
}

const mapStateToProps = state => ({ orders: state.order.orders });
const mapDispatchToProps = { getOrderPage };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderList));



// WEBPACK FOOTER //
// ./src/components/Orders/OrderList.js